import React, { useRef } from 'react';

import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import {
  DropdownButtonContainer,
  DropdownButton,
  ExpandIcon,
  ButtonLabel,
  DropdownListContainer,
  DropdownItemButton,
  DropdownItemLabel,
} from './styles';

export default function Dropdown({ value, icon, options = [], onChange, leftDrop, isDarkMode, width }) {
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);

  const toggleDropdown = () => setIsActive(!isActive);

  const optionClick = (option) => {
    onChange(option);
    setIsActive(false);
  };

  return (
    <DropdownButtonContainer ref={dropdownRef}>
      <DropdownButton isDarkMode={isDarkMode} onClick={toggleDropdown} width={width}>
        <ButtonLabel isDarkMode={isDarkMode}>
          {icon}
          {value}
        </ButtonLabel>
        <ExpandIcon isOpen={isActive} isDarkMode={isDarkMode} />
      </DropdownButton>
      {isActive && (
        <DropdownListContainer leftDrop={leftDrop} isDarkMode={isDarkMode}>
          {options.map((option, index) => (
            <DropdownItemButton key={index} isDarkMode={isDarkMode} onClick={() => optionClick(option)}>
              <DropdownItemLabel>
                {option.icon}
                {option.label}
              </DropdownItemLabel>
            </DropdownItemButton>
          ))}
        </DropdownListContainer>
      )}
    </DropdownButtonContainer>
  );
}
